import { de } from '@/i18n/de';
import { AppShell } from '@/components/AppShell';
import { Button } from '@/components/Button';

interface LocalDoneScreenProps {
  playerCount: number;
  mafiaCount: number;
  onRedeal: () => void;
  onExit: () => void;
}

export function LocalDoneScreen({
  playerCount,
  mafiaCount,
  onRedeal,
  onExit,
}: LocalDoneScreenProps) {
  return (
    <AppShell
      footer={
        <div className="mx-auto flex max-w-xl flex-col gap-2">
          <Button fullWidth variant="secondary" onClick={onRedeal}>
            {de.local.redeal}
          </Button>
          <Button fullWidth variant="ghost" onClick={onExit}>
            {de.local.exit}
          </Button>
        </div>
      }
    >
      <div className="flex h-full flex-col items-center justify-center gap-4 text-center">
        <span className="text-5xl" aria-hidden="true">
          🤫
        </span>
        <h1 className="font-display text-3xl font-extrabold">{de.local.doneTitle}</h1>
        <p className="text-fg-muted">{de.local.doneHint}</p>
        <p className="text-sm text-fg-faint">{de.local.doneSummary(playerCount, mafiaCount)}</p>
      </div>
    </AppShell>
  );
}
